import * as UIActions from '../../actions/UIActions';
import {defaultState} from '../state';
import {CLEAR_LOADER_ACTION} from '../../../common/actions/GlobalActions';

const loader = (state = defaultState.ui.loader, action) => {
    switch (action.type) {
        case UIActions.IS_LOADING_ACTION.name: {
            const ls = [...state];
            ls.push(action.payload);
            return [...ls];
        }
        case UIActions.IS_LOADED_ACTION.name: {
            const ls = [...state].filter(item => item !== action.payload);
            return [...ls];
        }
        case UIActions.CLEAN_STATE_ACTION.name:
        case CLEAR_LOADER_ACTION.name:
            return defaultState.ui.loader;
        default:
            return state;
    }
};

export default loader;
